import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';

var _templateObject, _templateObject2;
var InputContainer = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  color: ", ";\n  border: ", "\n    ", ";\n  box-shadow: ", ";\n  border-radius: 0;\n  background-color: ", ";\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme,
    invertColors = _ref.invertColors;
  return invertColors ? theme.palette.white : theme.palette.black;
}, function (_ref2) {
  var textarea = _ref2.textarea,
    disabled = _ref2.disabled;
  return !textarea && !disabled ? 'solid 2px' : 'none';
}, function (_ref3) {
  var theme = _ref3.theme,
    error = _ref3.error,
    success = _ref3.success,
    focus = _ref3.focus,
    invertColors = _ref3.invertColors;
  if (invertColors) {
    return theme.palette.white;
  }
  if (focus) {
    return theme.palette.secondaryLighter;
  } else {
    if (error) {
      return theme.palette.errorDark;
    } else if (success) {
      return theme.palette.success;
    }
    return theme.palette.grayLight;
  }
}, function (_ref4) {
  var invertColors = _ref4.invertColors;
  return invertColors && '0 0 0 2px transparent';
}, function (_ref5) {
  var theme = _ref5.theme,
    invertColors = _ref5.invertColors;
  return invertColors ? 'inherit' : theme.palette.white;
}, function (_ref6) {
  var focus = _ref6.focus,
    textarea = _ref6.textarea;
  return !textarea && focus && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      outline: none;\n      box-shadow: ", ";\n      border: ", ";\n    "])), function (_ref7) {
    var _ref7$theme = _ref7.theme,
      theme = _ref7$theme === void 0 ? themes.secureSite : _ref7$theme,
      invertColors = _ref7.invertColors;
    return invertColors && "0 0 0 2px ".concat(theme.palette.white);
  }, function (_ref8) {
    var _ref8$theme = _ref8.theme,
      theme = _ref8$theme === void 0 ? themes.secureSite : _ref8$theme,
      invertColors = _ref8.invertColors;
    return invertColors ? "solid 2px ".concat(theme.palette.white) : "solid 2px ".concat(theme.palette[theme.input.focusBorderColor]);
  });
});

export default InputContainer;
export { InputContainer };
